// loading.service.ts
import { Injectable, signal } from '@angular/core';
import { finalize, Observable } from 'rxjs';

export interface FileProgress {
  fileName: string;
  hash:string;
  progress: number;
}

export type Status ='init' | 'upload' | 'complete' | 'checking' | 'creating' | 'deleting' | 'loading' | 'updating' | ''

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSignal = signal(false);
  private progressSignal = signal<FileProgress[]>([]);
  private messageSignal = signal<string>('Loading...');
  private statusSignal = signal<Status>('');
  
  // 公开为只读 signals
  loading = this.loadingSignal.asReadonly();
  progress = this.progressSignal.asReadonly();
  message = this.messageSignal.asReadonly();
  status = this.statusSignal.asReadonly();

  // 显示加载 spinner
  show(message: string = 'Loading...', status: Status = ''): void {
    this.loadingSignal.set(true);
    this.statusSignal.set(status);
    this.messageSignal.set(message);
    this.progressSignal.set([]); // 重置进度
  }

  // 隐藏加载 spinner
  hide(): void {
    this.loadingSignal.set(false);
    this.progressSignal.set([]);
  }

 // 更新特定文件的进度
  updateFileProgress(fileName: string, hash:string, progress: number): void {
    const currentProgress = this.progressSignal();
    const fileIndex = currentProgress.findIndex(f => f.fileName === fileName);
    const hashIndex = currentProgress.findIndex(f => f.hash === hash)
    
    if (fileIndex >= 0 && hashIndex >=0) {
      // 更新现有文件进度
      const updatedProgress = [...currentProgress];
      updatedProgress[fileIndex] = { fileName, hash, progress };
      this.progressSignal.set(updatedProgress);
    } else {
      // 添加新文件进度
      this.progressSignal.set([...currentProgress, { fileName, hash, progress }]);
    }
  }
  // 更新消息
  updateMessage(message: string): void {
    this.messageSignal.set(message);
  }

    // 更新状态
  updateStatus(status: Status): void {
    this.statusSignal.set(status);
  }
    
   // 带自动隐藏的包装方法
  wrapWithLoading<T>(observable: Observable<T>, message: string, status: Status = ''): Observable<T> {
    this.show(message, status);
    return observable.pipe(
      finalize(() => this.hide())
    );
  }

  // 带进度跟踪的包装方法
  wrapWithProgress<T>(observable: Observable<T>, message: string = 'Uploading...', status:Status = 'upload'): Observable<T> {
    this.show(message, status);
    return observable;
  }

  // 获取当前加载状态
  get isLoading(): boolean {
    return this.loadingSignal();
  }
}